import Vue from 'vue';
import ElementUI from 'element-ui';
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import commons from './components/common/common'
import VueI18n from 'vue-i18n';
import { messages } from './components/common/i18n';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import './assets/css/theme-green/index.css'; // 浅绿色主题
import './assets/css/icon.css';
import './components/common/directives';
import 'babel-polyfill';
import http from './utils/request'
import axios from "axios";
import 'lib-flexible/flexible'
import defaultConfig from "../default.config";
//Antd
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import App from './App.vue';
import router from './router';
//配置wss
import global from '../wsglobal'
//引入播放器组件
import VideoPlayer from 'vue-video-player'
// import Blob from './excal/Blob.js'
// import Export2Excel from './excal/Export2Excel.js';
// 引入echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
// 支持m3u8
const hls = require('videojs-contrib-hls')
Vue.use(hls)
// main.js 文件
Vue.prototype.global = global

Date.prototype.format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1,                 //月份
        "d+": this.getDate(),                    //日
        "h+": this.getHours(),                   //小时
        "m+": this.getMinutes(),                 //分
        "s+": this.getSeconds(),                 //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds()             //毫秒
    };

    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }

    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(
                RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
    }

    return fmt;
}

Vue.prototype.COMMON = commons

console.log(Vue.prototype)

Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(ViewUI);
Vue.use(Antd);

Vue.use(ElementUI, {
    size: 'small'
});
const i18n = new VueI18n({
    locale: 'zh',
    messages
});
axios.defaults.baseURL = defaultConfig._BaseUrl
// axios.defaults.baseURL = 'http://192.168.1.190:8080/'
Vue.prototype.$http = http;
Vue.prototype.$axios = axios;
//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    // document.title = `${to.meta.title} | 后台管理系统`;
    const role = sessionStorage.getItem('token');
    // if(!role){
    //     window.location.href = defaultConfig._BaseUrl
    // }
    if (!role && to.path !== '/index' && !role && to.path !== '/login' && to.path !== '/pdsLogin' && !role && to.path !== '/copyrightJoin' && !role && to.path !== '/channelJoin' && to.path !== '/changePassword') {
        // next('/index');
        window.location.href = defaultConfig._BaseUrl
    } else if (to.meta.permission) {
        // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
        role === 'admin' ? next() : next('/403');
    } else {
        // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
        if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
            Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
                confirmButtonText: '确定'
            });
        } else {
            next();
        }
    }
});
new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app');